import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["alt", "color", "icon", "label", "size", "src", "srcset", "variant"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import { AVATAR_COLORS, AVATAR_SIZES, AVATAR_VARIANTS } from "../constants";
import { AvatarIcon, AvatarImage, AvatarText, AvatarWrapper } from "../elements";
import { jsx as _jsx } from "react/jsx-runtime";

var Avatar = function Avatar(_ref) {
  var alt = _ref.alt,
      color = _ref.color,
      icon = _ref.icon,
      label = _ref.label,
      size = _ref.size,
      src = _ref.src,
      srcset = _ref.srcset,
      variant = _ref.variant,
      other = _objectWithoutProperties(_ref, _excluded);

  var renderAvatarContent = function renderAvatarContent() {
    switch (variant) {
      case AVATAR_VARIANTS.IMAGE:
        return /*#__PURE__*/_jsx(AvatarImage, {
          alt: alt,
          src: src,
          srcset: srcset
        });

      case AVATAR_VARIANTS.ICON:
        return /*#__PURE__*/_jsx(AvatarIcon, {
          size: size,
          children: icon
        });

      case AVATAR_VARIANTS.TEXT:
        return /*#__PURE__*/_jsx(AvatarText, {
          label: label,
          size: size
        });

      default:
        return null;
    }
  };

  var avatarProps = _objectSpread({
    'aria-label': label,
    color: color,
    size: size
  }, other);

  return /*#__PURE__*/_jsx(AvatarWrapper, _objectSpread(_objectSpread({}, avatarProps), {}, {
    children: renderAvatarContent()
  }));
};

Avatar.displayName = "Avatar";
Avatar.propTypes = {
  /** Accessibility measurement for verbal image description */
  alt: PropTypes.node,

  /** Sets background color of avatar component */
  color: PropTypes.oneOf(Object.values(AVATAR_COLORS)),

  /** Outputs icon inside the avatar. Use icon component from the library */
  icon: PropTypes.node,

  /** Username, that this avatar depicts. */
  label: PropTypes.node.isRequired,

  /** Avatar wrapper size. Icon size changes depending on wrapper size */
  size: PropTypes.oneOf(Object.values(AVATAR_SIZES)),

  /** Path to image file */
  src: PropTypes.string,

  /** Defines multiple sizes of the same image, allowing the browser to select the appropriate image source */
  srcset: PropTypes.string,

  /** Avatar variant. Values: [EMPTY, TEXT, ICON, IMAGE]. Default TEXT */
  variant: PropTypes.oneOf(Object.values(AVATAR_VARIANTS))
};
Avatar.defaultProps = {
  alt: '',
  color: AVATAR_COLORS.COLOR_500,
  icon: null,
  size: AVATAR_SIZES.STANDARD,
  src: undefined,
  srcset: '',
  variant: AVATAR_VARIANTS.TEXT
};
export { Avatar };